<template>
  <v-data-table
    :headers="headers"
    :items="items"
    class="elevation-1"
    :loading="loading"
    loading-text="Carregando... Aguarde"
    :search="search"
    no-results-text="Nenhum resultado encontrado"
    locale="pt-BR"
    :options.sync="gridOptions"
    @update:options="saveLocalOptions"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-search"
          label="Pesquisa"
          single-line
          hide-details
          clearable
        ></v-text-field>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              :loading="loading"
              class="ml-3"
              :class="{ 'mr-3': !hasFilter }"
              v-on="on"
              @click="$emit('atualiza')"
            ><v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Atualizar</span>
        </v-tooltip>
        <v-tooltip v-if="hasFilter" bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              class="mr-3"
              v-on="on"
              @click="$emit('filtrar')"
            ><v-icon>mdi-filter</v-icon>
            </v-btn>
          </template>
          <span>Filtrar</span>
        </v-tooltip>
        <v-tooltip bottom v-if="hasBtnAdd">
          <template v-slot:activator="{ on }">
            <v-btn
              small
              color="primary"
              fab
              dark
              v-on="on"
              @click="$emit('novo')"
            ><v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Novo</span>
        </v-tooltip>
      </v-toolbar>
    </template>
    <template v-slot:item.cor="{ item }">
      <div>
        <v-chip small :color="item.cor"></v-chip>
      </div>
    </template>
    <template v-slot:item.status="{ item }">
      <v-chip :color="getColorByStatus(item.status)" small dark>{{ item.status }}</v-chip>
    </template>
    <template v-slot:item.dispositivo="{ item }">
      {{ item.dispositivo && item.dispositivo.split('/')[0] + `@${item.ip}` }}
    </template>
    <template v-slot:item.licencas="{ item }">
      <span v-for="licenca of item.licencas" :key="licenca._id">
        {{ licenca.titulo }} <br />
      </span>
    </template>
    <template v-slot:item.createdAt="{ item }">
      {{ item.createdAt | dateTime }}
    </template>
    <template v-slot:item.updatedAt="{ item }">
      {{ item.updatedAt | dateTime }}
    </template>
    <template v-slot:item.data_expiracao="{ item }">
      {{ item.data_expiracao | dateMonthYear }}
    </template>
    <template v-slot:item.expiresIn="{ item }">
      {{ item.expiresIn | dateTime }}
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        class="mr-5"
        @click="$emit('edit', item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        @click="$emit('destroy', item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <span class="pr-3">Nenhum registro encontrado</span>
      <v-btn
        text
        icon
        :loading="loading"
        class="mr-3"
        @click="$emit('atualiza')"
      >
        <v-icon>mdi-redo-alt</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from 'vuex';
import { statusColor } from '@/helpers';

  export default {
    name: 'Grid',
    data: () => ({
      search: '',
      gridOptions: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['title'],
        sortDesc: [false]
      }
    }),
    props: {
      title: {
        type: String,
        default: 'Título'
      },
      headers: {
        type: Array,
        default: () => [
          {
            text: 'Descrição',
            align: 'start',
            value: 'descricao',
          },
          { text: 'Status', value: 'status' },
          { text: 'Ações', value: 'actions', sortable: false },
        ]
      },
      items: {
        type: Array,
        default: () => []
      },
      sortBy: {
        type: String,
        default: 'descricao'
      },
      hasFilter: {
        type: Boolean,
        default: false
      },
      hasBtnAdd: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      ...mapGetters(['loading']),
    },
    methods: {
      getColorByStatus(status) {
        return statusColor(status);
      },
      loadLocalOptions() {
        if (localStorage.getItem(`Grid${this.title}Options`)) {
          this.gridOptions = JSON.parse(localStorage.getItem(`Grid${this.title}Options`));
        }
      },
      saveLocalOptions(event) {
        localStorage.setItem(`Grid${this.title}Options`, JSON.stringify(event));
      }
    },
    beforeMount() {
      this.loadLocalOptions();
    }
  }
</script>